export enum DateContextTypeEnum {
    TodayDate = 1,
    ComparisonDate = 2,
}